import { ExtractNode, ExtractTypeName, Query } from "./types";

export const getNode = <Q extends Query, T extends ExtractTypeName<Q>>(
  data: Q | undefined,
  type: T,
) => {
  if (!data || data.node?.__typename !== type) {
    return undefined;
  }

  return (data as ExtractNode<Q, T>).node;
};
